// Product text tabs hidden when empty

document.addEventListener("DOMContentLoaded", function () {
  const productTabs = document.querySelector(".sb_product-tabs");
  const tabsList = document.querySelector(".product-tabs-title");
  
  if (tabsList && tabsList.children.length === 0) {
    productTabs.style.display = "none";
  }
});



// Addons dropdown

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".sb_product-addon__heading").forEach(heading => {
    heading.addEventListener("click", function () {
      let dropdown = this.nextElementSibling;
      let icon = this.querySelector(".sb_product-addon__icon");
      dropdown.classList.toggle("active");
      icon.classList.toggle("active");
    });
  });

  document.addEventListener("click", function (event) {
    if (!event.target.closest(".sb_product-addon")) {
      document.querySelectorAll(".sb_product-addon__products").forEach(dropdown => {
        dropdown.classList.remove("active");
        dropdown.previousElementSibling.querySelector(".sb_product-addon__icon").classList.remove("active");
      });
    }
  });

  document.querySelectorAll('.sb_product-addon__input').forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.checked) {
        const heading = this.closest('.sb_product-addon').querySelector('.sb_product-addon__heading');
        const title = this.closest('.sb_product-addon__label').querySelector('.sb_product-addon__title');
        const price = this.closest('.sb_product-addon__label').querySelector('.sb_product-addon__price');
        
        heading.querySelector('.sb_product-addon__heading-js').textContent = '';
        heading.querySelector('.sb_product-addon__text-js').textContent = '';
        
        heading.querySelector('.sb_product-addon__heading-js').textContent = title.textContent;
        heading.querySelector('.sb_product-addon__text-js').textContent = price.textContent;
      }
    });
  });
});
